import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { DirectivesModule } from '../directives/directives.module'
import { MaterialModule } from '../material.module'
import { BaseDialogComponent } from './dialog-base/dialog-base.component'

@NgModule({
	declarations: [
		BaseDialogComponent
	],
	exports: [
		BaseDialogComponent
	],
	imports: [
		CommonModule,
		MaterialModule,
		DirectivesModule
	],
	providers: [
	],
	entryComponents: []
})
export class BaseAtylModule {
}
